import {gsap} from 'gsap';

( function( app ) {
  const COMPONENT = {
    init: function() {},
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'hero-banner', COMPONENT );
} )( app );
